<template>
    <div id="booking-payment-container" class="shadow-reg">
        <h6 class="heading-small text-muted text-uppercase montserrat mb-2">Payment Information</h6>
        <div class="payment-breakdown-container">
            <div class="payment-item text-default text-sm">
                Service Cost: <span class="price" v-text="serviceCost.toFixed(2)"></span>
            </div>
            <div class="payment-item text-default text-sm">
                VAT: <span class="price" v-text="vat.toFixed(2)"></span>
            </div>
            <div class="payment-item text-default text-sm">
                Booking Fee: <span class="price" v-text="bookingFee.toFixed(2)"></span>
            </div>
            <div v-if="unsettledPenalties" class="payment-item text-default text-white bg-danger text-sm font-weight-700">
                Penalties: <span class="price" v-text="unsettledPenalties.toFixed(2)"></span>
            </div>
            <div v-if="pointDiscount > 0" class="payment-item text-default text-sm">
                Points Discount: <span class="price"> -{{ pointDiscount.toFixed(2) }}</span>
            </div>
            <div v-if="voucherDiscount > 0" class="payment-item text-default text-sm">
                Voucher Discount: <span class="price"> -{{ voucherDiscount.toFixed(2) }}</span>
            </div>
            <div class="payment-item text-white bg-success text-sm font-weight-700">
                Transaction Cost: <span class="price" v-text="totalCost.toFixed(2)"></span>
            </div>
            <div class="payment-item text-default" style="font-size: 12px;border-width: 0px!important;">
                <checkbox class="inline-block" v-model="agreeOnTermsAndCondtition"></checkbox>
                I agree to the <a href="#" class="link-hover-line">Terms and Conditions</a> of Cutiefy
            </div>
            <div class="payment-item text-right" style="border-width: 0px!important;">
                <button v-if="isRequesting" class="btn btn-warning disabled" disabled style="height: 43px;">
                    <i class="fa fa-spinner fa-spin pr-1"></i> Please wait ...
                </button>
                <button v-else-if="agreeOnTermsAndCondtition && !isRequesting" class="btn btn-warning"  style="height: 43px;" @click="checkout">
                    Checkout <i class="fas fa-angle-right ml-2"></i>
                </button>
                <button v-else class="btn btn-warning disabled" disabled style="height: 43px;">
                    Checkout <i class="fas fa-angle-right ml-2"></i>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { getServiceVoucherDiscount, getBookingVoucherDiscount, getServiceCost, getTotalServiceVoucherDiscount, getTotalCost } from "../../../helpers/booking";
export default {
    name: "PaymentSection",

    computed: {
        bookingFee() {
            return parseFloat(this.$store.getters.shop.booking_fee);
        },
        vat() {
            return parseFloat(this.$store.getters.shop.vat || 0);
        },
        pointDiscount() {
            return parseFloat(this.pointsUsed * this.pointEquivalent);
        },
    },

    data: () => ({
        agreeOnTermsAndCondtition: 0,
        voucherDiscount: 0,
        serviceCost: 0,
        totalCost: 0,
    }),

    methods: {
        checkout() {
            this.$emit("checkout");
        },

        getServiceCost() {
            return getServiceCost({
                services: this.services,
                packages: this.packages,
            });
        },

        getVoucherDiscount() {
            return this.bookingVoucher
                ? getBookingVoucherDiscount(this.serviceCost, this.bookingVoucher)
                : getTotalServiceVoucherDiscount(this.services.concat(this.packages));
            
        },

        getTotalCost() {
            const total = getTotalCost(this.serviceCost,this.bookingFee,this.vat,this.unsettledPenalties,this.pointDiscount,this.voucherDiscount);
            return total || 0;
        },

        computeSummary() {
            this.serviceCost = this.getServiceCost();
            this.voucherDiscount = this.getVoucherDiscount();
            this.totalCost = this.getTotalCost();
        }
    },

    props: {
        pointsUsed: Number,
        pointEquivalent: Number,
        unsettledPenalties: Number,
        services: Array,
        packages: Array,
        isRequesting: Boolean,
        bookingVoucher: [Object],
    },

    mounted() {
        setTimeout(() => this.computeSummary(), 500);
    }
}
</script>
<style lang="css" scoped>
    #booking-payment-container {
        background-color: white;
        border-radius: 4px;
        padding: 24px 24px !important;
    }

    #booking-payment-container .payment-breakdown-container {
        margin: 0px -24px !important;
    }

    #booking-payment-container .payment-breakdown-container .payment-item {
        padding: 10px 24px !important;
        border-bottom: 1px solid #E9ECEF;
        font-weight: 400;
    }

    #booking-payment-container .payment-breakdown-container .payment-item .price {
        float: right;
        font-weight: 700 !important;
    }
</style>